import React from "react";
import "./Button.css";
function Button({ color, text, onClickFunction }) {
  return (
    <button style={{ backgroundColor: color }} onClick={onClickFunction}>
      {text}
    </button>
  );
}

export default Button;
